"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchQueryValidationDto = exports.UpdateShaftConstantDtoValidation = exports.DeleteShaftConstantDtoValidation = void 0;
const yup = require("yup");
const app_1 = require("./app");
exports.DeleteShaftConstantDtoValidation = yup.object({
    ids: yup.array().of(yup.number()).min(1).required(),
});
exports.UpdateShaftConstantDtoValidation = yup.object({
    id: yup.string().required(),
    value: yup.number().min(0.001).max(100).required(),
    name: yup.string(),
});
exports.SearchQueryValidationDto = yup.object({
    page: yup.number(),
    pageSize: yup.number(),
    name: yup.string(),
    sort: yup.object({
        key: yup.string(),
        order: yup.mixed().oneOf([app_1.SortOrder.ASC, app_1.SortOrder.DESC]),
    }),
});
//# sourceMappingURL=shaftConstant.js.map